var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1124px",
    height: "406px",
    viewBox: "0 0 1124 406",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "senX graphic tbf1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999918%",
    x2: "100%",
    y2: "49.999918%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EEEB",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EEEB",
    stopOpacity: 0.08962709,
    offset: "8.962709%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0EEEB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-SendX---L---Alternative-1.2",
    transform: "translate(-364.000000, -143.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "senX-graphic-tbf1",
    transform: "translate(364.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1114.2,213 L1114.2,182.1 C1114.2,179.6 1112.2,177.6 1109.7,177.6 L1094.1,177.6 C1091.6,177.6 1089.6,179.6 1089.6,182.1 L1089.6,213.5 L1080.8,213.5 L1080.8,136.6 C1080.8,134.1 1078.8,132.1 1076.3,132.1 L1049.6,132.1 C1047.1,132.1 1045.1,134.1 1045.1,136.6 L1045.1,242.1 L1024.4,242.1 L1024.4,202 C1024.4,199.5 1022.4,197.5 1019.9,197.5 L992.4,197.5 C989.9,197.5 987.9,199.5 987.9,202 L987.9,254.9 L970.3,254.9 L970.3,229 C970.3,226.5 968.3,224.5 965.8,224.5 L945.3,224.5 C942.8,224.5 940.8,226.5 940.8,229 L940.8,281.1 L917.9,281.1 L917.9,217.5 C917.9,215 915.9,213 913.4,213 L883,213 L883,182.1 C883,179.6 881,177.6 878.5,177.6 L862.9,177.6 C860.4,177.6 858.4,179.6 858.4,182.1 L858.4,213.5 L849.6,213.5 L849.6,136.6 C849.6,134.1 847.6,132.1 845.1,132.1 L818.4,132.1 C815.9,132.1 813.9,134.1 813.9,136.6 L813.9,212.1 L793.3,212.1 L793.3,172 C793.3,169.5 791.3,167.5 788.8,167.5 L761.3,167.5 C758.8,167.5 756.8,169.5 756.8,172 L756.8,254.9 L739.2,254.9 L739.2,229 C739.2,226.5 737.2,224.5 734.7,224.5 L714.2,224.5 C711.7,224.5 709.7,226.5 709.7,229 L709.7,281.1 L686.8,281.1 L686.8,217.5 C686.8,215 684.8,213 682.3,213 L652,213 L652,182.1 C652,179.6 650,177.6 647.5,177.6 L631.9,177.6 C629.4,177.6 627.4,179.6 627.4,182.1 L627.4,213.5 L618.6,213.5 L618.6,136.6 C618.6,134.1 616.6,132.1 614.1,132.1 L587.4,132.1 C584.9,132.1 582.9,134.1 582.9,136.6 L582.9,212.1 L562,212.1 L562,172 C562,169.5 560,167.5 557.5,167.5 L530,167.5 C527.5,167.5 525.5,169.5 525.5,172 L525.5,254.9 L507.9,254.9 L507.9,229 C507.9,226.5 505.9,224.5 503.4,224.5 L482.9,224.5 C480.4,224.5 478.4,226.5 478.4,229 L478.4,281.1 L455.5,281.1 L455.5,217.5 C455.5,215 453.5,213 451,213 L420.7,213 L420.7,182.1 C420.7,179.6 418.7,177.6 416.2,177.6 L400.6,177.6 C398.1,177.6 396.1,179.6 396.1,182.1 L396.1,213.5 L387.3,213.5 L387.3,136.6 C387.3,134.1 385.3,132.1 382.8,132.1 L356,132.1 C353.5,132.1 351.5,134.1 351.5,136.6 L351.5,212.1 L330.8,212.1 L330.8,172 C330.8,169.5 328.8,167.5 326.3,167.5 L298.8,167.5 C296.3,167.5 294.3,169.5 294.3,172 L294.3,254.9 L276.7,254.9 L276.7,229 C276.7,226.5 274.7,224.5 272.2,224.5 L251.7,224.5 C249.2,224.5 247.2,226.5 247.2,229 L247.2,281.1 L224.3,281.1 L224.3,217.5 C224.3,215 222.3,213 219.8,213 L189.5,213 L189.5,182.1 C189.5,179.6 187.5,177.6 185,177.6 L169.4,177.6 C166.9,177.6 164.9,179.6 164.9,182.1 L164.9,213.5 L156,213.5 L156,136.6 C156,134.1 154,132.1 151.5,132.1 L124.8,132.1 C122.3,132.1 120.3,134.1 120.3,136.6 L120.3,212.1 L99.6,212.1 L99.6,172 C99.6,169.5 97.6,167.5 95.1,167.5 L67.6,167.5 C65.1,167.5 63.1,169.5 63.1,172 L63.1,254.9 L45.5,254.9 L45.5,229 C45.5,226.5 43.5,224.5 41,224.5 L20.5,224.5 C18,224.5 16,226.5 16,229 L16,281.1 L0,281.1 L0,376 L1124,376 L1124,213 L1114.2,213 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,318.5 C137.6,318.5 120.1,337.1 99.6,360.1 C67.9,395.6 40,404.5 40,404.5 L240,404.5 C240,404.5 221.3,318.5 161,318.5 Z",
    id: "Path",
    fill: "#E8E6E1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.4,290 C811,290 785.9,313.8 760.6,333.2 C719.8,365.3 692.1,376 692.1,376 L1031.6,376 C1031.6,376 1026.5,330.5 987.1,330.5 C950.5,330.5 936,356.7 909.4,356.7 C880.4,356.7 874.5,290 834.4,290 Z",
    id: "Path_1_",
    fill: "#E8E6E1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(310.108000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 174.220000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.34,49.912 C25.5,49.912 18.292,42.772 18.292,33.932 C18.292,31.756 18.7,29.716 19.516,27.812 C21.964,21.964 27.676,17.884 34.34,17.884 C43.18,17.884 50.388,25.024 50.388,33.932 C50.388,41.616 45.016,47.94 37.808,49.504 C36.72,49.776 35.564,49.912 34.34,49.912 Z M12.716,7.684 C4.964,14.008 -1.95509529e-13,23.596 -1.95509529e-13,34.272 C-1.95509529e-13,53.176 34.34,95.2 34.34,95.2 C34.34,95.2 49.912,76.092 60.112,57.868 C65.076,49.028 68.68,40.392 68.68,34.272 C68.68,15.368 53.312,-8.14623036e-14 34.34,-8.14623036e-14 C26.18,0.068 18.632,2.924 12.716,7.684 Z",
    id: "Fill-339",
    fill: "#F68B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.34,49.912 C25.5,49.912 18.292,42.772 18.292,33.932 C18.292,31.756 18.7,29.716 19.516,27.812 C21.964,21.964 27.676,17.884 34.34,17.884 C43.18,17.884 50.388,25.024 50.388,33.932 C50.388,41.616 45.016,47.94 37.808,49.504 C36.72,49.776 35.564,49.912 34.34,49.912 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M695.292,164.4 C691.192,164.4 687.792,161.1 687.792,157 C687.792,152.9 691.092,149.6 695.292,149.6 C699.492,149.6 702.792,152.9 702.792,157 C702.792,161.1 699.392,164.4 695.292,164.4 Z M679.292,157.2 C679.292,165.9 695.292,185.4 695.292,185.4 C695.292,185.4 711.292,166 711.292,157.2 C711.292,148.5 704.092,141.4 695.292,141.4 C686.492,141.4 679.292,148.5 679.292,157.2 Z",
    id: "Fill-340",
    fill: "#F68B24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line-2",
    transform: "translate(34.892000, 0.000000)",
    stroke: "#FF8502",
    strokeDasharray: 5.00000001525879,
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,170 C0.5,170 87.508,0 321.108,0 C554.708,0 660,137.5 660,137.5",
    id: "path-3_1_"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 695.292,
    cy: 157,
    rx: 7.5,
    ry: 7.4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M960.3,404.5 C962,404.5 963.5,403.2 963.6,401.4 C964.1,393.6 966.6,387.3 970.9,382.9 C976.6,377.1 984.6,375.9 990.3,375.9 C1000.6,375.9 1006.5,379.7 1009.7,382.9 C1014,387.3 1016.4,393.6 1017,401.4 C1017.1,403.1 1018.6,404.5 1020.3,404.5 L1062.6,404.5 C1064.5,404.5 1066,402.9 1065.9,401.1 C1064.3,359.8 1033.1,330.6 990.3,330.6 C947.5,330.6 916.4,359.8 914.7,401.1 C914.6,403 916.1,404.5 918,404.5 L960.3,404.5 Z",
    id: "Path",
    fill: "#F68B24",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(470.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 187.1,
    y1: 156.3,
    x2: 187.1,
    y2: 136.4,
    id: "XMLID_22_",
    stroke: "#686868",
    strokeWidth: 3.4142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9,175.7 L95.2,175.7 C96.6,175.7 97.8,176.9 97.8,178.3 L97.8,185.8 L92.8,185.8 L78,185.8 L68,185.8 C67.9,180.2 72.4,175.7 77.9,175.7 Z",
    id: "XMLID_42_",
    fill: "#363636",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_30_",
    fill: "#FDB693",
    fillRule: "nonzero",
    points: "92.9 164.5 82.1 166.2 83.9 175.7 95 175.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_50_",
    transform: "translate(2.000000, 170.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_52_",
    fill: "#363636",
    transform: "translate(26.983230, 26.271190) rotate(-13.009219) translate(-26.983230, -26.271190) ",
    cx: 26.98323,
    cy: 26.27119,
    r: 21.6992459
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_51_",
    fill: "#FFFFFF",
    transform: "translate(26.994810, 26.295330) rotate(-14.045971) translate(-26.994810, -26.295330) ",
    cx: 26.99481,
    cy: 26.29533,
    r: 11.4999845
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_48_",
    transform: "translate(188.000000, 156.000000)",
    fill: "#F44A5E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0.3 L11,0.3 C13.3,0.3 15.2,2.2 15.2,4.6 L15.2,14.6 L0.5,14.6 L0.5,0.3 L11,0.3 Z",
    id: "XMLID_49_"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_47_",
    fill: "#363636",
    fillRule: "nonzero",
    transform: "translate(155.177890, 196.265570) rotate(-13.009219) translate(-155.177890, -196.265570) ",
    cx: 155.17789,
    cy: 196.26557,
    r: 21.6992459
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_46_",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(155.170000, 196.292310) rotate(-67.163289) translate(-155.170000, -196.292310) ",
    cx: 155.17,
    cy: 196.29231,
    r: 11.499817
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.9,202 L153.6,202.1 C155.2,202.1 156.5,200.8 156.5,199.2 L156.5,199.2 C156.5,197.6 155.2,196.3 153.6,196.3 L111.9,196.2 C111.1,196.2 110.4,196.9 110.4,197.7 L110.4,200.5 C110.4,201.3 111,202 111.9,202 Z",
    id: "XMLID_45_",
    fill: "#B8B8B8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_44_",
    fill: "#FDB693",
    fillRule: "nonzero",
    points: "114.8 29.6 100.3 29.6 100.2 66.5 114.7 63.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2,173.8 L96.2,173.8 L88.3,126 L107,126 L107,112.5 L81,112.5 C76.1,112.5 72.3,116.9 73.2,121.8 L82.2,173.8 Z",
    id: "XMLID_43_",
    fill: "#363636",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,29.5 C111.1,17.8 101.2,8.2 101.2,8.2 L77,18.4 L77,39 C77,47.3 83.7,54 91.9,53.9 C106,53.8 110,52.4 112.5,41.3 L112.5,29.5 Z",
    id: "XMLID_41_",
    fill: "#FDB693",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_37_",
    fill: "#363636",
    fillRule: "nonzero",
    transform: "translate(60.558307, 74.932695) rotate(-89.895074) translate(-60.558307, -74.932695) ",
    cx: 60.5583073,
    cy: 74.9326953,
    r: 6.5000109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,90 C42.9,90 48.4,95.6 48.4,102.5 C48.4,109.4 42.8,114.9 35.9,114.9 L26.6,114.9 L26.6,90 L36,90 Z",
    id: "XMLID_36_",
    fill: "#F68B24",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2,126 L132.7,126.1 C136.5,126.1 139.5,129.2 139.5,132.9 L139.5,132.9 C139.5,136.7 136.4,139.7 132.7,139.7 L90.3,139.6 L88.2,126 Z",
    id: "XMLID_35_",
    fill: "#545454",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,0.9 C117.8,0.9 122.2,16.6 122.2,23.5 C122.2,34.8 117.3,39 114.8,39 L97.2,39 L97.2,28.1 L74,28.1 L74,23.9 C74,10.2 84.8,0.9 97,0.9 Z",
    id: "XMLID_32_",
    fill: "#363636",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_31_",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 74,
    y: 28.1,
    width: 23.2,
    height: 10.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,58.8 L116.4,58.8 C116.4,58.8 140.5,85.4 129.8,126 C121.3,126 97.6,125.9 97.6,125.9 L97.6,58.8 L97.6,58.8 Z",
    id: "XMLID_29_",
    fill: "#F68B24",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6,160.9 L37.3,160.9 C43.6,160.9 48.7,155.8 48.7,149.5 L48.8,102.4 L56.6,102.5 L56.4,185.7 L95.4,185.8 C104.6,185.8 112.1,178.4 112.1,169.1 L112.1,156.4 C112.1,147.2 104.7,139.7 95.4,139.7 L148.2,139.8 C179.5,139.9 204.8,165.2 204.700295,196.5 L118.6,196.3 L118.6,196.3 L68.9,196.2 L58.8,196.2 L28.9,196.1 L23.7,187.6 L0.7,187.6 C0.8,172.8 12.8,160.9 27.6,160.9 Z",
    id: "XMLID_28_",
    fill: "#F68B24",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_",
    transform: "translate(122.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,0.6 L48.9,0.7 C61,0.7 70.7,10.5 70.7,22.6 L70.7,45.4 L0.4,45.3 L0.5,10.6 C0.4,5 4.9,0.6 10.4,0.6 Z",
    id: "XMLID_27_",
    fill: "#686868",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.7,
    y1: 15.2,
    x2: 13.1,
    y2: 15.2,
    id: "XMLID_26_",
    stroke: "#363636",
    strokeWidth: 3.4142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.1,
    y1: 22.3,
    x2: 13,
    y2: 22.3,
    id: "XMLID_25_",
    stroke: "#363636",
    strokeWidth: 3.4142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.5,
    y1: 29.3,
    x2: 13,
    y2: 29.3,
    id: "XMLID_24_",
    stroke: "#363636",
    strokeWidth: 3.4142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_21_",
    stroke: "#363636",
    strokeWidth: 3.4142,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "59.1 75 48.9 75 48.8 105.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_20_",
    fill: "#363636",
    fillRule: "nonzero",
    transform: "translate(30.432329, 102.329245) rotate(-179.895077) translate(-30.432329, -102.329245) ",
    x: 26.7323228,
    y: 89.8792236,
    width: 7.40001241,
    height: 24.9000418
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,69 C106.5,67.6 102.6,69.3 101.3,72.8 L95.4,87.7 C94.6,89.8 92.8,91.4 90.6,91.9 L56.5,100.4 L59.7,113.5 L93.8,105 C100.2,103.4 105.5,98.8 107.9,92.7 L113.8,77.8 C115.1,74.3 113.4,70.4 110,69 L110,69 Z",
    id: "XMLID_13_",
    fill: "#FDB693",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_12_",
    fill: "#FDB693",
    fillRule: "nonzero",
    cx: 57.5,
    cy: 105.2,
    r: 8.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_11_",
    fill: "#363636",
    fillRule: "nonzero",
    cx: 59.1,
    cy: 112.4,
    r: 4.4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,90.4 C146.7,90.3 146.9,96.8 148.3,110.9 C148.6,114.4 149.4,121.6 150.6,132.3 C150.9,134.6 152.8,136.3 155,136.3 L199.8,136.3 C202.1,136.3 204.1,134.5 204.3,132.2 C205.2,121.9 205.6,111.6 205.6,101.4 C205.6,89.9 203.9,69.8 203.9,69.8 L203.7,68.4 C203.4,66.2 201.5,64.6 199.3,64.6 L151,64.6 C148.6,64.6 146.6,66.5 146.5,68.9 L146.3,74 C146.3,84.1 146.6,90.4 146.8,90.4 Z",
    id: "Path",
    fill: "#F68B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6,146 L150.7,146 C154.1,146 157.3,144.4 159.4,141.6 L160.1,140.6 C162.1,137.9 165.4,136.2 168.8,136.2 L211.3,136.2",
    id: "Path",
    stroke: "#686868",
    strokeWidth: 3.4142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.4,75.1 L181.4,75.1 L163.6,75.1 C161.5,75.3 159.8,76.1 158.6,77.7 C157.1,79.6 153.2,84.9 151.8,87 C150.6,88.8 149,90.4 146.8,90.4",
    id: "Path",
    stroke: "#363636",
    strokeWidth: 1.3614,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.3,132.2 C205.1,122.4 205.5,112.6 205.6,102.8 C203.2,110.5 197.9,116.3 189.8,120.1 C185.1,122.3 178.9,124.9 168.2,127 C160,128.4 152.7,129 150.3,129 C150.4,130 150.5,131.1 150.7,132.2 C151,134.5 152.9,136.2 155.1,136.2 L199.9,136.2 C202.1,136.3 204.1,134.5 204.3,132.2 Z",
    id: "Path",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110,69 C106.5,67.6 102.6,69.3 101.3,72.8 L95.4,87.7 C94.6,89.8 92.8,91.4 90.6,91.9 L66.3,98 L71.6,110.5 L93.9,105 C100.3,103.4 105.6,98.8 108,92.7 L113.9,77.8 C115.1,74.3 113.4,70.4 110,69 Z",
    id: "Path",
    fill: "#F68B24",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: 83.7,
    x2: 109.2,
    y2: 89,
    id: "Path",
    stroke: "#F0EEEB",
    strokeWidth: 5.4457
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    fill: "#F68B24",
    fillRule: "nonzero",
    points: "116.4 55.8 97.6 55.8 97.6 66.5 116.4 65.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.6,71.5 L122.1,71.5 C120.4,71.5 119.1,72.8 119.1,74.5 C119.1,76.2 120.4,77.5 122.1,77.5 L127.2,77.5 C126.4,75.3 125.5,73.3 124.6,71.5 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6,103.7 C102.3,101.5 106,97.6 107.9,92.7 L113.8,77.8 C115.2,74.3 113.5,70.4 110,69.1",
    id: "Path",
    stroke: "#363636",
    strokeWidth: 1.3614,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.2,53.7 C103.4,53.3 105.7,52.7 107.5,51.4 C107.5,51.4 105.7,54.9 100.2,54.9 L100.2,53.7 Z",
    id: "XMLID_3_",
    fill: "#363636",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(692.000000, 294.302564)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 1.1,
    x2: 26.2,
    y2: 1.1,
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.8,
    y1: 17.6,
    x2: 62.1,
    y2: 17.6,
    id: "Line-4-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.1,
    y1: 34,
    x2: 37.3,
    y2: 34,
    id: "Line-4-Copy-2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/main-bg.cb1b891a1a77b90877bcb4739a492d1a.svg";
export { ForwardRef as ReactComponent };